<bwh-lib-step-control-bar
  [langDropdown]="true"
  [prevBut]="prevBut"
  [closeBut]="closeBut"
  [currentStep]="wizardService?.currentStep"
  [previousStep]="wizardService?.previousStep"
  [steps]="wizardService?.totalSteps"
  (emitClose)="close()"
  (emitPrev)="goPrev()"
>
</bwh-lib-step-control-bar>
<div class="selecting-job text-center step-wrapper">
  <div class="main-header">
    <h1 class="main-title">{{ 'global.select_your_job' | translate }}</h1>
    <p class="main-description">
      {{
        (editing
          ? 'global.select_your_job_description_editing'
          : !wizardService?.isManualFlow
          ? 'global.select_your_job_description_cv_flow'
          : 'global.select_your_job_description'
        ) | translate
      }}
    </p>
  </div>
  <form class="scrollable-content" [formGroup]="form">
    <lib-single-select-search
      class="main-search"
      #searchAutocomplete
      [options]="filteredJobsList"
      [placeholder]="'global.search_for_your_job' | translate"
      [iconPath]="'/icons/search-icon.svg'"
      [staticIcon]="true"
      [myFloatLabel]="'never'"
      [addDebounce]="300"
      [clearInput]="true"
      [waitForOptionsChange]="true"
      [suggestionsOff]="true"
      [detectScrollToEnd]="true"
      (changed)="handleFilteredOptionClick($event)"
      (valueChanged)="handleValueChangedSearch($event)"
      (scrolledToEnd)="handleScrolledToEndSearch($event)"
    >
    </lib-single-select-search>
    <div
      geluidsapparatuur
      *ngIf="dataLoaded"
      cdkDropList
      [cdkDropListData]="selectedJobs.controls"
      class="selected-jobs scrollbar"
      formArrayName="selectedJobs"
      (cdkDropListDropped)="changePositionInJobsList($event)"
    >
      <div
        cdkDrag
        [cdkDragData]="item"
        *ngFor="let item of selectedJobs.controls; let i = index"
        class="job-item"
        [ngClass]="{ 'item-clickable': itemClickable }"
        (click)="editJob(i)"
      >
        <bwh-lib-selected-item
          cdkDragHandle
          [formGroupName]="i"
          hoverInfoText="form.field.provide_more_info"
          [name]="item.get('position_name').value || item.get('position_name_original').value"
          [listIcon]="true"
          [twoIcons]="true"
          [openIcon]="true"
          [index]="i + 1"
          [expIndex]="exp_index + 1"
          [iconStatus]="validityChecking(i, item.status)"
          (actionTriggered)="removeJob($event)"
        >
        </bwh-lib-selected-item>
        <div class="job-exp-container" [ngClass]="{ opened: i === exp_index }">
          <div class="drag-hide" [ngClass]="{ opened: exp_opened }" cdkDragPreview>
            <bwc-your-experience
              [formGroup]="form"
              [expIndex]="i"
              [jobsList]="getJobsListForIndex(i)"
              [loadedJobsFullList]="loadedJobsFullList"
              (click)="stopPropagation($event)"
            ></bwc-your-experience>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="
        dataLoaded && !editing && wizardService && !wizardService?.isManualFlow && selectedJobs.controls.length === 0
      "
      class="order-tip mt-5"
      role="alert"
    >
      {{ 'global.select_your_job_cv_no_professions' | translate }}
    </div>

    <div
      *ngIf="dataLoaded && wizardService?.isManualFlow && !editing && selectedJobs.controls.length === 0"
      class="order-tip mt-5"
      role="alert"
    >
      {{ 'global.select_your_job_no_job_tip' | translate }}
    </div>

    <div *ngIf="dataLoaded && editing && selectedJobs.controls.length === 0" class="order-tip mt-5" role="alert">
      {{ 'global.select_your_job_editing_no_professions' | translate }}
    </div>

    <div *ngIf="dataLoaded && selectedJobs.controls.length > 1 && !editing" class="order-tip mt-5" role="alert">
      {{ 'global.select_your_job_order_tip' | translate }}
    </div>

    <ul class="next-button-container">
      <li *ngIf="prevBut === true">
        <button class="btn w-md h-lg primary prev-btn" type="button" (click)="goPrev()">
          {{ 'global.previous' | translate }}
        </button>
      </li>
      <li>
        <button
          *ngIf="!editing"
          class="btn w-md h-lg secondary"
          type="submit"
          [disabled]="!this.form.valid"
          (click)="nextStep()"
        >
          {{ 'global.next_button' | translate }}
        </button>
      </li>
      <li *ngIf="editing">
        <button class="btn w-md h-lg primary" type="button" (click)="emitClose.emit('cancelled')">
          {{ 'global.cancel' | translate }}
        </button>
      </li>
      <li *ngIf="editing">
        <button class="btn w-md h-lg secondary" type="text" (click)="onEdit()" [disabled]="!this.form.valid">
          {{ 'global.done' | translate }}
        </button>
      </li>
    </ul>
  </form>
</div>
